// extracted by mini-css-extract-plugin
export default {"container":"payout-tiers-table_container__utmN3"};